export class ComparisonEmojimodel {
  constructor() {
    this.id = null;
    this.title = "";
    this.description = "";
    this.answer = "";
    this.taskType = "";
  }
}
